import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { KeyboardArrowDown } from '@clds/icon';
import { Button, ButtonProps, TextWrapper } from '@clds/button';

const PreventPointerEvents = styled.div`
  pointer-events: none;
`;

//istanbul ignore next
export interface StyledButtonProps {
  customHeight?: `${number}${'%' | 'px'}`;
}
const StyledButton = styled(Button)<StyledButtonProps>`
  width: 100%;
  background: ${(props) => props.theme.palette.backgroundAlt};

  ${({ customHeight }) =>
    customHeight &&
    css`
      height: ${customHeight};
    `}

  ${TextWrapper} {
    text-align: left;
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export type TriggerProps = ButtonProps & StyledButtonProps;

export const Trigger = forwardRef<HTMLButtonElement, TriggerProps>((props, ref) => (
  <StyledButton ref={ref} rightSlot={<KeyboardArrowDown size="sm" />} variant="secondary" tone="surface" size="sm" {...props} />
));

export const SingleTrigger = forwardRef<HTMLButtonElement, TriggerProps>((props, ref) => (
  <PreventPointerEvents>
    <Trigger ref={ref} rightSlot={null} tabIndex={-1} {...props} />
  </PreventPointerEvents>
));
